import { Typography, Box, Button, FormControl, Stack, MenuItem, InputLabel, Select } from "@mui/material";
import { useState, useEffect } from "react";
import React from "react";
import MockData from "../../helper/MockData";
import { InfoApi } from "../../api/InfoApi";
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import { AdminApi } from "../../api/AdminApi";
import AdminLeaderboardCard from "../../components/app/AdminLeaderboardCard";
import EventList from "../../components/app/EventList";
import { getCurrentDateStr } from "../../helper/StringHelper";
import { dateValueToYYYYMMDD } from "../../helper/TimeHelper";
import EventLeaderboardQueryForm from "../../components/adminLeaderboard/EventLeaderboardQueryForm";


function downloadCsvData(csvData, filename) {
  console.debug("downloadCsvData: ", csvData, filename);
  // Convert csvData to CSV string
  let csvContent = "";

  for (let row of csvData) {
    // console.debug("row: ", row);
    // Convert each row to a comma-separated string
    const rowString = row.map(item => {
      // Escape double quotes by replacing them with two double quotes
      const escapedItem = item.toString().replace(/"/g, '""');
      // Wrap the item in double quotes
      return `"${escapedItem}"`;
    }).join(",");
    // Append the row string to the CSV content
    csvContent += rowString + "\n";
  }

  console.debug("csvContent: ", csvContent);
  // Create a Blob from the CSV string
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  // Create a link element
  const link = document.createElement("a");
  // Create a URL for the Blob    
  const url = URL.createObjectURL(blob);
  // Set the link's href to the Blob URL
  link.setAttribute("href", url);
  // Set the download attribute with the filename
  link.setAttribute("download", filename);
  // Append the link to the body
  document.body.appendChild(link);
  // Programmatically click the link to trigger the download
  link.click();
  // Clean up by removing the link and revoking the Blob URL

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  console.debug("CSV file downloaded: ", filename);
}

function generateCsvData(event, leaderboard) {
  console.debug("generateCsvData: ", event, leaderboard);
  // Generate CSV data from eventStat and skillStatList
  const headerColumns = [
    "Skill Name",
    "Rank",
    "Score",
    "Member Name",
    "Phone Number",
    "QR Code",
  ];

  let csvData = [];

  // Add header row
  csvData.push(headerColumns);

  // // loop through skillStatList
  for (let skillData of leaderboard) {
    const skillCode = skillData.skill_code || "";
    const skillName = skillData.skill_name || skillCode;

    const topRecords = skillData.result || [];
    // let rank = 1;
    for (let data of topRecords) {
      let rank = data.rank || 0;
      let score = data.score || 0;
      let members = data.members || [];

      for (let member of members) {

        let memberName = member.name || "";
        let phone = member.phone_num || "";
        let qrcodeID = member.qrcode_id || "";

        csvData.push([
          skillName,
          rank,
          score,
          memberName,
          phone,
          qrcodeID,
        ]);
      }

    }

  }

  console.debug("csvData: ", csvData);

  return csvData;

}

function getLeadboardTable(leaderboard, selectedSkill) {
  if (leaderboard == null) {
    return <Box>Not Ready</Box>;
  }

  const leaderboardItems = leaderboard.map((item) => {
    if (selectedSkill !== 0 && item.id !== selectedSkill) {
      return <></>;
    }
    return <AdminLeaderboardCard key={item.id} leaderboardItem={item} />
  });




  return <Stack dirction="column">
    {leaderboardItems}
    {/* <Box>Leaderboard</Box>
    <pre>
      {JSON.stringify(leaderboard, null, 2)}
    </pre> */}
  </Stack>
}

export default function AdminLeadboardSection({ mode = "admin", userID }) {
  const [eventList, setEventList] = useState([]);
  const [event, setEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [timeslot, setTimeslot] = useState(1);
  const [skillID, setSkillID] = useState(0);
  const [leaderboard, setLeaderboard] = useState(null);
  const { t } = useTranslation();

  const hasQuery = leaderboard !== null;

  // 
  const isAdminUser = mode === "admin";
  userID = userID || 0;

  let lang = getLang();

  useEffect(() => {
    if (isAdminUser) {
      loadAllEventList();
    } else {
      loadUserEventList();
    }

  }, []);

  const onTimeslotChanged = (event) => {
    setTimeslot(event.target.value);
  };

  const onQueryLeaderboard = async (inputData) => {
    console.debug("onQueryLeaderboard: ", inputData);

    const eventID = inputData.eventID || 0;
    const timeslotID = inputData.timeslotID || 0;
    const skillID = inputData.skillID || 0;
    const selectedDate = inputData.selectedDate || null;
    const selectedDateRange = inputData.selectedDateRange || null;

    const selectedDateStr = selectedDate ? dateValueToYYYYMMDD(selectedDate) : "";

    const startDate = selectedDateRange[0];
    const endDate = selectedDateRange[1];

    console.debug("selectedDateStr: ", selectedDateStr);
    console.debug("startDate: ", startDate, " endDate: ", endDate);

    const result = await AdminApi.loadEventLeaderboardData(eventID, startDate, endDate);
    console.debug("result: ", result);
    if (result) {
      setSkillID(skillID);
      setLeaderboard(result);
    } else if (result.length === 0) {
      setLeaderboard([]);
      // setLeaderboard(result);
      // alert("No data");    
      // alert("Success");
    } else {
      alert("Failed to load leaderboard");
    }
  };

  const onQuery = async () => {
    // alert('query');

    // ken: need to fix 
    const eventID = process.env.REACT_APP_LEADERBOARD_EVENT || 4;
    // const eventID = 3;
    const date = getCurrentDateStr();

    const result = await AdminApi.loadEventLeaderboard(eventID, date, timeslot, true);
    console.debug("result: ", result);
    if (result) {
      setLeaderboard(result);
      // alert("Success");
    } else {
      alert("Failed to load leaderboard");
    }
  }

  const updateEventList = (newEventList) => {
    setEventList(newEventList);


    if (newEventList.length === 0) {
      // setEvent([]);
    } else {
      setEvent(newEventList[0]);
    }
  }

  const loadUserEventList = async () => {
    setIsLoading(true);
    // console.debug("currentMemberID: ", currentMemberID);
    const result = await InfoApi.getUserEventList(userID);
    console.debug("**** result: ", result);
    updateEventList(result);
    setIsLoading(false);

  };



  const loadAllEventList = async () => {
    // console.debug("currentMemberID: ", currentMemberID);
    setIsLoading(true);
    const result = await InfoApi.getEventList();
    console.debug("result: ", result);
    updateEventList(result);
    setIsLoading(false);
    // setEventList(result);
  };

  if (isLoading) {
    return <Box>Loading...</Box>;
  }

  if( eventList.length === 0 ) {
    return <Box>暫沒有任何活動，如需要舉辦活動，請聯繫管理員。</Box>;
  }

  const selectionItems = event.timeslotList.map((timeslot) => {
    return <MenuItem value={timeslot.id}>{timeslot.timeslot_caption}</MenuItem>;
  });

  //<MenuItem value={timeslot.id}>{timeslot.timeslot_caption}</MenuItem>

  const selection = <FormControl fullWidth>
    <InputLabel id="eventID-label">Timeslot</InputLabel>
    <Select
      labelId="timeslot-label"
      id="timeslot_id"
      value={timeslot}
      label="Event"
      onChange={onTimeslotChanged}
    >
      {selectionItems}
    </Select>
  </FormControl>;

  const leaderboardTable = getLeadboardTable(leaderboard, skillID);

  const onExportCSV = async () => {
    console.debug("exportCSV: ", event);
    if (!event) {
      alert("Load leaderboard first");
      return;
    }

    const csvData = generateCsvData(event, leaderboard);
    const eventName = event.name_en || "Event";
    const filename = `leaderboard_${eventName}.csv`;
    // console.debug("csvData: ", csvData);
    // console.debug("filename: ", filename);
    downloadCsvData(csvData, filename);
  };

  return (
    <Stack direction="column" spacing={2}>
      <EventLeaderboardQueryForm eventList={eventList} onQuery={onQueryLeaderboard}>

      </EventLeaderboardQueryForm>

      {
        hasQuery &&
        <Button variant="contained" onClick={onExportCSV}>
          {t("button.export_csv")}
        </Button>

      }


      {leaderboardTable}
      <Box>
        <pre>
          {/* isAdminUser: {isAdminUser ? "true" : "false"}<br />
          userID: {userID}<br /> */}
          {/* {JSON.stringify(eventList, null, 2)} */}

          {/* {JSON.stringify(leaderboard, null, 2)} */}
          {/* {JSON.stringify(event, null, 2)} */}
        </pre>
      </Box>

    </Stack>
  );
}
